import { __decorate } from "tslib";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NavPaneContentComponent } from "./nav-pane-content/nav-pane-content.component";
import { MatIconModule } from "@angular/material/icon";
import { NavComponent } from "./nav.component";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { NavToolbarContentComponent } from "./nav-toolbar-content/nav-toolbar-content.component";
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";
export let NavModule = class NavModule {
};
NavModule = __decorate([
    NgModule({
        schemas: [CUSTOM_ELEMENTS_SCHEMA],
        declarations: [NavComponent,
            NavPaneContentComponent,
            NavToolbarContentComponent,
        ],
        exports: [NavComponent],
        imports: [
            CommonModule,
            MatIconModule,
            RouterModule,
            MatButtonModule,
            MatSidenavModule,
            MatToolbarModule,
            NgbAccordionModule,
        ]
    })
], NavModule);
